<section class="content-header">

    <h1 style=" float:left; width: auto"> New Signups </h1>
    <div class="pull-right input_search">
        <div class="input_search_inner pull-left">
            <input class="search_input" type="text" placeholder="Search" [(ngModel)]="Search">
            <i class="fa fa-times" (click)="clearSearch()"></i>
        </div>
    </div>
    <div class="clearfix"></div>
    <hr />
</section>

<!-- Main content -->
<section class="content container-fluid">
    <div class="table-responsive table-design">
        <table class="table table-fill" matSort (matSortChange)="sortData($event)" id="recordset" [style.visibility]="Resizing ? 'hidden' : 'visible'">
            <thead>
                <tr>
                    <th mat-sort-header="Company_name">Co.Name</th>
                    <th mat-sort-header="user_role">Relationship</th>
                    <th>Co.Address</th>
                    <th mat-sort-header="City">City</th>
                    <th mat-sort-header="State">State</th>
                    <th>Zip</th>
                    <th>Co.Phone Number</th>
                    <th>Details</th>
                </tr>
            </thead>
            <tbody *ngIf="posts?.length == 0">
                <tr>
                    <td colspan="13">
                        <div class="noRecord" id="Norecord">
                            <h3 style="color:#dd4b39;">No Records Found!</h3>
                        </div>
                    </td>
                </tr>
            </tbody>
            <tbody class="table-hover" *ngIf="posts?.length > 0" id="tableBody">
                <tr *ngFor="let  post of posts | productSearchFilter :{CompanyName:Search, City:Search, State:Search, Zip:Search, CompanyPhoneNumber:Search, UserRole:Search} | paginate: { itemsPerPage: ItemsPerPage, currentPage: CurrentPage,totalItems:ll.TotalCount}">
                    <td>{{post.CompanyName}}</td>
                    <td>{{post.UserRole}}</td>
                    <td>{{post.CompanyAddress}}</td>
                    <td>{{post.City}}</td>
                    <td>{{post.State}}</td>
                    <td>{{post.Zip}}</td>
                    <td>{{post.CompanyPhoneNumber}}</td>
                    <td>
                        <a (click)="MerchantDetails(post.IdMerchant)" class="btn btn-danger btn-sm">View Detail</a>
                    </td>
                </tr>
            </tbody>
        </table>

    </div>
    <ng-container *ngIf="posts?.length > 0">
        <div class="my_pagination" id="paginate" [style.visibility]="Resizing ? 'hidden' : 'visible'">
            <pagination-controls (pageChange)="pageChange($event)"></pagination-controls>
        </div>
    </ng-container>
    <!-- =======================view detail popup ==========================-->
    <div id="user_detail" class="modal fade user_profile input_list_style" role="dialog">
        <div class="modal-dialog modal-lg topRed">

            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                    <h4 class="modal-title">Users Profile Information</h4>
                </div>
                <form name="form1" #heroForm="ngForm" novalidate>
                    <div class="modal-body">
                        <ul class="list-inline list-unstyled">
                            <li>
                                <label class="text-danger">Company Name :</label>
                                <input [value]='CompanyName' name="name" type="text" class="form-control" placeholder="Company Name"
                                    [(ngModel)]="CompanyName" #Company="ngModel" required>

                                <div *ngIf="Company.errors && (Company.dirty || Company.touched)" class="error_main_div">
                                    <div [hidden]="!Company.errors.required" class="error_message">
                                        Company Name is Mandatory !
                                    </div>
                                </div>
                            </li>

                            <li>
                                <label class="text-danger">Company Street :</label>
                                <input [value]='CompanyAddress' name="address" type="text" class="form-control"
                                    placeholder="Company Address" [(ngModel)]="CompanyAddress" #Address="ngModel"
                                    required>
                                <div *ngIf="Address.errors && (Address.dirty || Address.touched)" class="error_main_div">
                                    <div [hidden]="!Address.errors.required" class="error_message">
                                        Company Street is Mandatory !
                                    </div>
                                </div>
                            </li>
                              <li>
                                    <label class="text-danger">Relationship :</label>
                                    <mat-form-field class="mat100">
                                            <mat-select placeholder="Choose here" [(ngModel)]="userrole" #t4 name="role"
                                                #role="ngModel" required>
                                                <mat-option value="Merchant">Merchant</mat-option>
                                                <mat-option value="Distributor">Distributor</mat-option>
                                               
                                            </mat-select>
                                        </mat-form-field>
                                    <!-- <div *ngIf="streetaddress.errors && (streetaddress.dirty || streetaddress.touched)" class="error_main_div">
                                        <div [hidden]="!streetaddress.errors.required" class="error_message">
                                            Company Street Address is Mandatory !
                                        </div>
                                    </div> -->
                                </li>

                            <li>
                                <label class="text-danger">Company phone Number :</label>
                                <input [textMask]="{mask: mask}" [value]='CompanyPhoneNumber' name="number" type="text"
                                    class="form-control" placeholder="Company Phone Number" [(ngModel)]="CompanyPhoneNumber"
                                    #Phone="ngModel" required>
                                <div *ngIf="Phone.errors && (Phone.dirty || Phone.touched)" class="error_main_div">
                                    <div [hidden]="!Phone.errors.required" class="error_message">
                                        Company phone Number is Mandatory
                                    </div>
                                </div>
                            </li>


                            <li>
                                <label class="text-danger">Country :</label>
                                <mat-form-field class="mat100">
                                    <mat-select placeholder="Choose Country here" [(ngModel)]="selectedcountry" #t3 (ngModelChange)="onChangeCountry(t3.value)"
                                        name="country" #Country="ngModel" required>
                                        <mat-option *ngFor="let countrylist of countrylists" [value]="countrylist.IdCountry">
                                            {{countrylist.CountryName}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <div *ngIf="Country.errors && (Country.dirty || Country.touched)" class="error_main_div">
                                    <div [hidden]="!Country.errors.required" class="error_message">
                                        Country Number is Mandatory
                                    </div>
                                </div>
                            </li>


                            <li>
                                <label class="text-danger">State :</label>
                                <mat-form-field class="mat100">
                                    <mat-select placeholder="Choose State here" [(ngModel)]="selectedState" #t2 (ngModelChange)="onChangeState(t2.value)"
                                        name="stat" #statee="ngModel" required>
                                        <mat-option *ngFor="let state of states" [value]="state.IdState">
                                            {{state.StateName}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <div *ngIf="statee.errors && (statee.dirty || statee.touched)" class="error_main_div">
                                    <div [hidden]="!statee.errors.required" class="error_message">
                                        State is Mandatory
                                    </div>
                                </div>
                            </li>

                            <li>
                                <label class="text-danger">City :</label>
                                <mat-form-field class="mat100">
                                    <mat-select placeholder="Choose City here" [(ngModel)]="selectedcity" name="city" #cityy="ngModel"
                                        required>
                                        <mat-option *ngFor="let city of citys" [value]="city.IdCity">
                                            {{city.CityName}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <div *ngIf="cityy.errors && (cityy.dirty || cityy.touched)" class="error_main_div">
                                    <div [hidden]="!cityy.errors.required" class="error_message">
                                        State is Mandatory
                                    </div>
                                </div>
                            </li>

                            <li>
                                <label class="text-danger">Zip :</label>
                                <input [value]='Zip' name="Zip" type="text" (focusout)="ZipcodeExist()" class="form-control" placeholder="Zip"
                                    [(ngModel)]="Zip" #zipcode="ngModel" required>
                                <div *ngIf="zipcode.errors && (zipcode.dirty || zipcode.touched)" class="error_main_div">
                                    <div [hidden]="!zipcode.errors.required" class="error_message">
                                        Zip is Mandatory
                                    </div>
                                </div>
                            </li>

                            <li>
                                <label class="text-danger">Contact Person :</label>
                                <input [value]='ContactPerson' name="ContactPerson" type="text" class="form-control"
                                    placeholder="Contact Person" [(ngModel)]="ContactPerson" #contactperson="ngModel"
                                    required>
                                <div *ngIf="contactperson.errors && (contactperson.dirty || contactperson.touched)"
                                    class="error_main_div">
                                    <div [hidden]="!contactperson.errors.required" class="error_message">
                                        Contact Person is Mandatory
                                    </div>
                                </div>
                            </li>

                            <li>
                                <label class="text-danger">Contact Person Phone :</label>
                                <input [textMask]="{mask: mask}" [value]='ContactPersonNumber' name="ContactPersonNumber"
                                    type="text" class="form-control" placeholder="Contact Person Number" [(ngModel)]="ContactPersonNumber"
                                    #contactname="ngModel" required>
                                <div *ngIf="contactname.errors && (contactname.dirty || contactname.touched)" class="error_main_div">
                                    <div [hidden]="!contactname.errors.required" class="error_message">
                                        Contact Person Phone is Mandatory
                                    </div>
                                </div>
                            </li>


                            <li>
                                <label class="text-danger">Login E-Mail Id:</label>
                                <input [value]='ContactPersonEmailId' name="ContactPersonEmailId" type="text" class="form-control"
                                    placeholder="Contact Person EmailId" [(ngModel)]="ContactPersonEmailId" #id="ngModel"
                                    pattern='^([\w\-\.]+)@((\[([0-9]{1,3}\.){3}[0-9]{1,3}\])|(([\w\-]+\.)+)([a-zA-Z]{2,4}))$'
                                    required>
                                <div *ngIf="id.errors && (id.dirty || id.touched)" class="error_main_div">
                                    <div [hidden]="!id.errors.required" class="error_message">
                                        Login E-Mail Id is Mandatory
                                    </div>
                                    <div [hidden]="!id.errors.pattern" class="error_message">
                                        Email Id invalid
                                    </div>
                                </div>
                            </li>


                            <li>
                                <label class="text-danger">Tenant Skin FQDN:</label>
                                <input [value]='FQDN' id="Dns"  name="FDNField" type="text" class="form-control" placeholder="Enter FQDN ' vend4you.com '"
                                    [(ngModel)]="FQDN" #Fqdnid="ngModel" >

                                    <!-- <div *ngIf="Fqdnid.errors && (Fqdnid.dirty || Fqdnid.touched)" class="error_main_div">
                                        <div [hidden]="!Fqdnid.errors.pattern" class="error_message">
                                            Enter valid Tenant Skin FQDN
                                        </div>
                                    </div> -->
                            </li>

                            <li>
                                <label class="text-danger">Select Skin Styles :</label>
                                <mat-form-field class="mat100">
                                    <mat-select placeholder="No Skin Selected" [(ngModel)]="skinStyle" name="skinStyleName" #skintemplate
                                    (ngModelChange)="onChangeSkin(skintemplate.value)" #skinStylee="ngModel" >
                                         <mat-option  [value]=null>
                                            No Skin Selected
                                        </mat-option>
                                        <mat-option *ngFor="let skin of skinStylesArray" [value]="skin.V4USkinId">
                                            {{skin?.Name}}
                                        </mat-option>
                                       
                                    </mat-select>
                                </mat-form-field>
                                
                            </li>
                        </ul>
                    </div>
                    <div class="clearfix"></div>
                    <div class="modal-footer">
                        <div class="pull-left">
                            <button (click)="Accept()" type="button" class="btn btn-danger">Accept</button>
                            <button (click)="Reject()" type="button" class="btn btn-danger">Reject</button>
                            <button (click)="update()" type="button" class="btn btn-danger" [disabled]="!heroForm.form.valid">Update
                                Details</button>
                        </div>
                        <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
                    </div>
                </form>
            </div>
        </div>

    </div>

    <div id="colorTheme" class="modal fade">
        <div class="modal-dialog modal_downSuccess">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="icon-box-color">
                        <i class="fa fa-times"></i>
                    </div>
                    <h4 class="modal-title"></h4>
                </div>
                <div class="modal-body">
                    <p class="text-center" style="font-size:32px;">{{responseUpdate}}</p>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-danger btn-block" (click)="responseUpdate=''" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!--Data downloaded successfully modal-->
    
    
    
    <div class="modal fade del_modal" data-backdrop="static" data-keyboard="false" id="errorZip" role="dialog">
        <div class="modal-dialog modal-sm">
            <div class="modal-content">
                <div class="modal-header" style="position:relative;">
                    <h4 class="modal-title">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                    </h4>
                </div>
                <div class="modal-body">
                    <p>{{responseZip}}</p>
                </div>
                <div class="modal-footer">
                    <div class="row">
                        <div class="col-sm-6">
                            <button type="button" class="btn btn-success" data-dismiss="modal" (click)="checkZipGoogleApi()">Yes</button>
                        </div>
                        <div class="col-sm-6">
                            <button  type="button" (click)="No()" class="btn btn-danger" data-dismiss="modal">No</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="alert alert-info alert-dismissable fade in" id="alert_div">
        <div id="alert_text" class="text-center">
            <strong>{{AlertText}}</strong>
        </div>
    </div>
</section>
<!-- /.content -->